<template>
  <b-modal v-model="config.model"
           v-bind="config"
           body-class="p-3"
           hide-footer
           @hidden="hiddenModal"
  >
    <template slot="modal-header">
      <h2 class="w-100">
        {{ title || resource['user.EditMemberText'] }}
      </h2>
      <button type="button"
              aria-label="Close"
              class="close xl"
              @click="hiddenModal"
      >
        ×
      </button>
    </template>

   <validation-observer ref="addMemberObserver"
                         v-slot="{passes, invalid}"
    >
      <b-form @submit.prevent="passes(memberUpdate)"
              @reset.prevent="hiddenModal"
      >
        <div>
          <b-row>
            <b-col cols="6" class="pr-2">
              <span class="fw-500">{{resource['member.Name']}}</span>
              <validate-form id="member-edit-name-text"
              v-model="value.name"
              rules="required|max:32000|noUrl"
              :placeholder="resource['memberName.Placeholder']"
              :name="resource['member.Name']"
              @keypress="maxLengthCheck($event, 75, 'name')"
              @keyup="maxLengthCheck($event, 75, 'name')"
              class-form="w-100 mt-2"/>
            </b-col>
            <b-col cols="6">
              <span class="fw-500">{{resource['member.Surname']}}</span>
              <validate-form id="member-edit-surname-text"
              v-model="value.surname"
              rules="required|max:32000|noUrl"
              :placeholder="resource['memberSurname.Placeholder']"
              :name="resource['member.Surname']"
              @keypress="maxLengthCheck($event, 75, 'surname')"
              @keyup="maxLengthCheck($event, 75, 'surname')"
              class-form="w-100 mt-2"/>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-3">
            <b-col cols="12">
              <span class="fw-500">{{resource['member.Email']}}</span>
              <validate-form id="member-edit-email-text"
              v-model="value.email"
              rules="required|max:32000|email"
              :placeholder="resource['memberEmail.Placeholder']"
              :name="resource['member.Email']"
              :disabled="true"
              @keypress="maxLengthCheck($event, 300, 'email')"
              @keyup="maxLengthCheck($event, 300, 'email')"
              class-form="w-100 mt-2"/>
            </b-col>
          </b-row>
        </div>

        <div class="modal-footer">
          <button id="memberSendButton"
                  class="btn md m-0 mt-4 btn-act"
                  :class="{'valid' : !invalid}"
                  :disabled="isChanged || buttonLoading"
                  type="submit"
          >
            {{ resource['member.Update'] }}
          </button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteModal',
  props: {
    value: {
      type: Object,
      required: true,
    },
    orgMemberModel: {
      type: Array,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    loader: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: undefined,
    },
    confirmText: {
      type: String,
      default: undefined,
    },
    buttonLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      config: {
        size: 'md',
        centered: true,
        model: this.value.show,
      },
      btnLoader: false,
      isChanged: false,
    };
  },
  watch: {
    'value.show': {
      handler(newVal) {
        this.config.model = newVal;
      },
    },
    value: {
      handler(newVal) {
        const isChanged = JSON.stringify(newVal) === JSON.stringify(...this.orgMemberModel);
        if (isChanged) {
          this.isChanged = true;
        } else {
          this.isChanged = false;
        }
        this.config.model = newVal.show;
      },
      deep: true,
    },
  },
  methods: {
    hiddenModal() {
      this.$emit('closeModal');
    },
    memberUpdate() {
      this.$emit('callBack', this.value);
    },
    setWhichInput(InpEl, value) {
      if (InpEl === 'name') {
        this.value.name = value;
      } else if (InpEl === 'surname') {
        this.value.surname = value;
      } else {
        this.value.email = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.row{
  margin:0;
}
.col-6,.col-12 {
  padding:0;
}
.fw-500 {
  font-weight: 500 !important;
}
.modal-footer{
  border-top: none;
  padding:0;
}
.btn-act{
  color: #FFFFFF;
  background: #C2C2C2;
  border-radius: 4px;
  &.valid{
    background: #FF8D06;
  }
}
</style>
